import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  reports: null,
  selected_report_index: null,
  setting_loading: false,
  email_loading: false,
};

const fundReportSlice = createSlice({
  name: 'fundReport',
  initialState,
  reducers: {
    setReports: (state, action) => {
      state.reports = action.payload;
    },
    setReportIndex: (state, action) => {
      state.selected_report_index = action.payload;
    },
    setSettingLoading: (state, action) => {
      state.setting_loading = action.payload;
    },
    setEmailLoading: (state, action) => {
      state.email_loading = action.payload;
    },
  },
});

export const {
  setReports,
  setReportIndex,
  setSettingLoading,
  setEmailLoading,
} = fundReportSlice.actions;
export default fundReportSlice.reducer;
